import { PageTitle as BasePageTitle } from '@ztechapps/webui.page'

export const siteName = 'Total Milk Hauler'

type PageTitleProps = {
  title: string
}

// App-local siteName over the shared PageTitle — follows apps/panelpunches/store/src/components/PageTitle.tsx:36-64
export const PageTitle = ({ title }: PageTitleProps) => <BasePageTitle title={title} siteName={siteName} noTitleTag />
